module.exports = __webpack_public_path__ + "img/collar width.ec1f66e9.png";